export function castcomment() {
    const open = [...document.querySelectorAll(".js-comment_open")];
    const close = [...document.querySelectorAll(".js-comment_close")];

    open.forEach((el) => {
        el.addEventListener("click", (e) => {
            e.preventDefault()
            e.stopPropagation()
            document.body.classList.add("-comment_modal");
        });
    });

    close.forEach((el) => {
        el.addEventListener("click", () => {
            document.body.classList.remove("-comment_modal");
        });
    });
}
